import {
  Button,
  ButtonVariants,
  COLUMN_GROUP_NATIVE_TYPE,
  FormControlSizes,
  HStack,
  IconName,
  type Column,
  type ColumnGroup,
} from '@talos/kyoko';
import type { ColDef, IHeaderGroupParams } from 'ag-grid-community';
import type { PriceGridEntity } from '../PriceGridEntity';

export const PRICE_GRID_ADD_PRICE_COLUMN_GROUP_ID = 'PriceGridAddPriceColumn';

function PriceGridAddPriceColumnHeader(
  params: IHeaderGroupParams & {
    onAddClick: (params: IHeaderGroupParams) => void;
  }
) {
  return (
    <HStack w="100%" justifyContent="center" data-testid="price-grid-add-price-column-tour-anchor">
      <Button
        size={FormControlSizes.Tiny}
        variant={ButtonVariants.Default}
        startIcon={IconName.Plus}
        aria-label="Add Price column"
        data-testid="price-grid-add-price-column-button"
        onClick={event => {
          event.stopPropagation();
          params.onAddClick(params);
        }}
      />
    </HStack>
  );
}

export function getPriceGridAddPriceColumnGroup({
  onAddClick,
}: {
  onAddClick: (params: IHeaderGroupParams) => void;
}): ColumnGroup {
  const addPriceColumn: Column<ColDef, PriceGridEntity> = {
    type: 'custom',
    id: `${PRICE_GRID_ADD_PRICE_COLUMN_GROUP_ID}-button`,
    title: '',
    lockPosition: 'right',
    initialWidth: 44,
    minWidth: 44,
    maxWidth: 44,
    suppressHeaderMenuButton: true,
    suppressColumnsToolPanel: true,
    sortable: false,
    params: {
      colId: `${PRICE_GRID_ADD_PRICE_COLUMN_GROUP_ID}-button`,
      headerName: '',
      lockVisible: true,
      resizable: false,
      valueGetter: () => '',
    },
  };

  return {
    type: COLUMN_GROUP_NATIVE_TYPE,
    groupId: PRICE_GRID_ADD_PRICE_COLUMN_GROUP_ID,
    headerName: '',
    marryChildren: true,
    suppressColumnsToolPanel: true,
    headerGroupComponent: PriceGridAddPriceColumnHeader,
    headerGroupComponentParams: {
      onAddClick,
    },
    children: [addPriceColumn],
  };
}
